import React, {Fragment,useState,useEffect,Suspense} from 'react';
import { Table,Row, Col,
  Card, CardBody,
  CardTitle,Button } from 'reactstrap';
import Parametri from '../../parametri';

import FormGridFormRow from '../SchedaAbbonamento/FormGridFormRow';
import TabellaRicerca from '../tabellaricerca.js';
import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import Interrogativo from '../../immagini/interrogativo-azzurro.png';

//const STATO_INDEFINITO = 0;
const STATO_RICERCA_DATI = 1;
const STATO_OPERAZIONE_CORRETTA= 2;
const STATO_ERRORE_CONNESSIONE= 3;
const STATO_VAI_IN_MODIFICA= 4;
const STATO_VAI_IN_ELIMINA= 5;
const STATO_VAI_IN_INSERISCI= 6;

function TabellaAbbonamenti(props) {
    
    const operazione = "elencoAbbonamenti";
      
    const [risultatoServer,setRisultatoServer]=useState('');
    //const [esitorisultatoServer,setEsitoRisultatoServer]=useState('');
    const [statoPagina,setStatoPagina]=useState(STATO_RICERCA_DATI);
    const [error,setError]=useState('');

    const [idModifica,setIdModifica]=useState('');
    
    const [filtroArchiviati,setFiltroArchiviati]=useState(0);

    const [flagModaleInfoPopolamento, setFlagModaleInfoPopolamento] = React.useState(false);

    //const override = {position: "absolute",left: "50%",top: "50%",zIndex: 1000};


    const colonne = [
      {
        etichetta: '',
        accessor: 'ID'
      },
      {
        etichetta: 'Nome Abbonamento',
        accessor: 'NOME',
        pdf: 1,
      },
      {
        etichetta: 'Classe Abbonamento',
        accessor: 'CLASSE_ABBONAMENTO_ELENCOVIRGOLA',
        pdf: 1,
      },
      {
        etichetta: 'Importo',
        accessor: 'IMPORTO',
        pdf: 1,
      },

    ];
    const arrayTipiDati=[];
    arrayTipiDati[3]="importo";
    
                          
    function VaiModifica(id) {
      setStatoPagina(STATO_VAI_IN_MODIFICA);
      setIdModifica(id);
    }

    function VaiElimina(id) {
      setStatoPagina(STATO_VAI_IN_ELIMINA);
      setIdModifica(id);
    }

    function callbackTermineModifica() {
      setStatoPagina(STATO_RICERCA_DATI);
    }
    useEffect(() => {
      if (props.flagResetPagine) {
        setStatoPagina(STATO_RICERCA_DATI);
        props.callbackFlagResetPagine(false);
      }
    }, [props.flagResetPagine])

    useEffect(() => {
      if(statoPagina===STATO_RICERCA_DATI){
        // parametri per inviare i dati al server:
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:operazione,filtro_archiviati:filtroArchiviati,emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){
            setRisultatoServer(valoreDiRitorno.risultatoRitorno);
            //setEsitoRisultatoServer(valoreDiRitorno.risultatoOperazione);
            setStatoPagina(STATO_OPERAZIONE_CORRETTA);
          }
        },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
      }    
    },[statoPagina])

    function tornaElenco() {
      setFlagModaleInfoPopolamento(false);
  }

  return (
      <div>

      {statoPagina === STATO_VAI_IN_INSERISCI ? 
        <div>
        <Suspense fallback={
          <div className="loader-container">
          <div className="loader-container-inner"><h6 className="mt-5">Caricamento scheda abbonamento in corso...</h6></div>
          </div>
        }>
        <FormGridFormRow {...props} ope={"inserisci"} callbackTermineModifica={callbackTermineModifica} sessionId={props.sessionId}></FormGridFormRow>
        </Suspense>
      </div>
      :""} 

      {statoPagina === STATO_VAI_IN_MODIFICA ? 
        <div>
          <Suspense fallback={
            <div className="loader-container">
            <div className="loader-container-inner"><h6 className="mt-5">Caricamento scheda abbonamento in corso...</h6></div>
            </div>
          }>
          <FormGridFormRow {...props} id={idModifica} ope={"modifica"} callbackTermineModifica={callbackTermineModifica} sessionId={props.sessionId}></FormGridFormRow>
          </Suspense>
        </div>
      :""} 

      {statoPagina === STATO_VAI_IN_ELIMINA ? 
        <div>
          <Suspense fallback={
            <div className="loader-container">
            <div className="loader-container-inner"><h6 className="mt-5">Caricamento scheda abbonamento in corso...</h6></div>
            </div>
          }>
          <FormGridFormRow {...props} id={idModifica} ope={"cancella"} callbackTermineModifica={callbackTermineModifica} sessionId={props.sessionId}></FormGridFormRow>
          </Suspense>
        </div>
      :""} 

      {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1E_Abb</div> :""}  
      {statoPagina === STATO_RICERCA_DATI ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}

      {statoPagina === STATO_OPERAZIONE_CORRETTA ?
        <div style={{height: props.dimensioniApp.yMain, overflow:"hidden", display:"flex", flexDirection:"column"}}>

              {flagModaleInfoPopolamento=== true ?
                    <Modale 
                        larghezza = "lg"
                        titolo="Informativa Abbonamenti Disponibili / Archiviati"
                        flagErrore={false}
                        contenuto={<div>
                          Gli abbonamenti definiti disponibili sono quelli che gli iscritti possono sottoscrivere. <br></br>
                          È possibile archiviare un abbonamento tramite il pulsante Archivia presente nella sua scheda. <br></br>
                          Un abbonamento archiviato non sarà più disponibile per la sottoscrizione da parte degli iscritti, ma rimarrà utile per mantenere i dati storici relativi agli abbonati che hanno attualmente o hanno avuto l'abbonamento in esame.<br></br><br></br>

                          E' sempre possibile ripristinare un abbonamento archiviato tra quelli disponibili.<br></br>
                          Basta accedere all'elenco degli archiviati (dall'elenco degli abbonamento disponibili, bottone VisualizzaAbbonamenti Archiviati), quindi selezionare l'abbonamento e premere il pulsante Riporta nei Disponibili.</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {tornaElenco()}
                            }    
                        ]}
                    />
                :""}

          <CardBody>
            <CardTitle>
              {filtroArchiviati === 0 ? <Fragment>Elenco Abbonamenti Disponibili</Fragment> : <Fragment>Elenco Abbonamenti Archiviati</Fragment>}            
            </CardTitle>
            {filtroArchiviati === 0 ? 
              <Fragment>
                <Button color="success" className="bottoneMargineADestra" onClick={() => setStatoPagina(STATO_VAI_IN_INSERISCI)}>Nuovo</Button>
                <Button color="success" onClick={() => {setFiltroArchiviati(1);setStatoPagina(STATO_RICERCA_DATI)}}>Visualizza Abbonamenti Archiviati</Button>
              </Fragment>
            : 
              <Button color="success" onClick={() => {setFiltroArchiviati(0);setStatoPagina(STATO_RICERCA_DATI)}}>Visualizza Abbonamenti Disponibili</Button>
            }     
            <img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagModaleInfoPopolamento(true)}/>                       
          </CardBody>
          {risultatoServer !== undefined && risultatoServer !== "" ?
            filtroArchiviati === 0 ?
              <TabellaRicerca 
              titolo={`Elenco Abbonamenti Disponibili`} 
              columns={colonne} data={risultatoServer} arrayTipiDati={arrayTipiDati} campoChiave={0} campoOrdinamento={1} nascondiColonna={0} callbackSelezionaElemento={VaiModifica} callbackEliminaElemento={VaiElimina}/>
            :
              <TabellaRicerca 
              titolo={`Elenco Abbonamenti Archiviati`} 
              columns={colonne} data={risultatoServer} arrayTipiDati={arrayTipiDati} campoChiave={0} campoOrdinamento={1} nascondiColonna={0} callbackSelezionaElemento={VaiModifica} callbackEliminaElemento={VaiElimina}/>
          : 
            <Table responsive bordered hover striped className="mb-0">
            <thead>
              <tr>
                <th>Nessun dato presente</th>
              </tr>
            </thead>
            </Table>
          }
        </div>        
      :""}
    </div>
   );
}
export default TabellaAbbonamenti;